import React, { useEffect, useState } from "react";
import { endpoints } from "@/lib/api";
import PageHero from "@/components/PageHero";
import { HERO } from "@/lib/heroImages";

/**
 * RitualsHero — kept minimal and consistent with every other page hero.
 * Uses the shared PageHero so sizing, imagery, and copper wash all match.
 * The week's theme (if available) is threaded into the eyebrow/supporting
 * line so the reflective invitation still lives in the banner.
 */
export default function RitualsHero() {
  const [theme, setTheme] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await endpoints.themedWeekCurrent();
        if (alive) setTheme(data);
      } catch { /* hero still renders without the weekly line */ }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <PageHero
      emblem=""
      eyebrow={theme ? `This Week · ${theme.name}` : "Filling Your Cup"}
      title="Filling Your Cup"
      supporting={theme?.ritual_invitation}
      image={HERO.rituals}
      testid="rituals-hero"
    />
  );
}
